export const clientActivityTableData = {
    keys: [
        "code",
        "logbook",
        "parent",
        "display_order",
        "deeming_agency",
        "deeming_agency_frequency",
        "edit_form",
        "activity_type",
        "standard",
        "standard_tooltip",
        "activity_description",
        "activity_text",
        "activity_tooltip",
        "code_reference",
        "code_reference_tooltip",
        "frequency",
        "test_frequency",
        "quarterly_view",
        "completion_threshold",
        "email_threshold",
        "default_total_devices",
        "start_date",
        "end_date",
        "shift",
        "category",
        "shift_start",
        "shift_end",
        "is_active",
        "created_at",
        "updated_at"
    ],
    config: {
        code: {
            isVisible: true,
            label: "Code",
            class: "",
            searchKey: "client_activities.code",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "code"
        },
        parent: {
            isVisible: true,
            label: "Parent",
            class: "",
            searchKey: "client_activities.parent",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "parent"
        },
        deeming_agency_frequency: {
            isVisible: true,
            label: "DA Frequency",
            class: "",
            searchKey: "deeming_agency_frequencies.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "deeming_agency_frequency",
            commonSearchKey: "deeming_agency_frequencies",
            commonSearchObjectKey: "name"
        },
        is_active: {
            isVisible: true,
            label: "Is Active?",
            class: "",
            searchKey: "client_activities.is_active",
            type: "boolean",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "is_active"
        },
        calculate_next_event: {
            isVisible: true,
            label: "Calculate Next Event?",
            class: "",
            searchKey: "activities.calculate_next_event",
            type: "boolean",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "calculate_next_event"
        },
        activity_type: {
            isVisible: true,
            label: "Activity Type",
            class: "",
            searchKey: "client_activities.activity_type",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "activity_type"
        },
        schedule_threshold: {
            isVisible: true,
            label: "Schedule Threshold",
            class: "",
            searchKey: "client_activities.schedule_threshold",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "schedule_threshold"
        },
        logbook: {
            isVisible: true,
            label: "Logbook",
            class: "",
            searchKey: "client_logbooks.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "logbooks",
            commonSearchKey: "logbooks",
            commonSearchObjectKey: "name"
        },
        deeming_agency: {
            isVisible: true,
            label: "Deeming Agency",
            class: "",
            searchKey: "deeming_agencies.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "deeming_agency",
            commonSearchKey: "deeming_agencies",
            commonSearchObjectKey: "name"
        },
        display_order: {
            isVisible: true,
            label: "Display Order",
            class: "",
            searchKey: "client_activities.display_order",
            type: "float",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "display_order"
        },
        standard: {
            isVisible: true,
            label: "Standard",
            class: "",
            searchKey: "client_activities.standard",
            type: "window",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "standard"
        },
        standard_tooltip: {
            isVisible: true,
            label: "Standard Tooltip",
            class: "",
            searchKey: "client_activities.standard_tooltip",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "standard_tooltip"
        },
        activity_description: {
            isVisible: true,
            label: "Activity Description",
            class: "",
            searchKey: "client_activities.activity_description",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "activity_description"
        },
        activity_text: {
            isVisible: true,
            label: "Activity text",
            class: "",
            searchKey: "client_activities.activity_text",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "activity_text"
        },
        activity_tooltip: {
            isVisible: true,
            label: "Activity Tooltip",
            class: "",
            searchKey: "client_activities.activity_tooltip",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "activity_tooltip"
        },
        interval_type: {
            isVisible: true,
            label: "Interval Type",
            class: "",
            searchKey: "client_activities.interval_type",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "interval_type"
        },
        frequency: {
            isVisible: true,
            label: "Frequency",
            class: "",
            searchKey: "client_activities.frequency",
            type: "rrule",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "frequency"
        },
        test_frequency: {
            isVisible: true,
            label: "Test Frequency",
            class: "",
            searchKey: "client_activities.test_frequency",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "test_frequency"
        },
        completion_threshold: {
            isVisible: true,
            label: "Completion Threshold",
            class: "",
            searchKey: "client_activities.completion_threshold",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "completion_threshold"
        },
        email_threshold: {
            isVisible: true,
            label: "Email Threshold",
            class: "",
            searchKey: "client_activities.email_threshold",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "code"
        },
        code_reference: {
            isVisible: true,
            label: "Code Reference",
            class: "",
            searchKey: "client_activities.code_reference",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "code_reference"
        },
        code_reference_tooltip: {
            isVisible: true,
            label: "Code Reference Tooltip",
            class: "",
            searchKey: "client_activities.code_reference_tooltip",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "code_reference_tooltip"
        },
        quarterly_view: {
            isVisible: true,
            label: "Quarterly View",
            class: "",
            searchKey: "client_activities.quarterly_view",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "quarterly_view"
        },
        edit_form: {
            isVisible: true,
            label: "Event Form",
            class: "",
            searchKey: "client_activities.edit_form",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "edit_form"
        },
        default_total_devices: {
            isVisible: true,
            label: "Default Total Devices",
            class: "",
            searchKey: "client_activities.default_total_devices",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "default_total_devices"
        },
        start_date: {
            isVisible: true,
            label: "Valid From",
            class: "",
            searchKey: "client_activities.start_date",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "start_date"
        },
        end_date: {
            isVisible: true,
            label: "Valid To",
            class: "",
            searchKey: "client_activities.end_date",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "end_date"
        },
        shift: {
            isVisible: true,
            label: "Shift",
            class: "",
            searchKey: "client_activities.shift",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "shift"
        },
        category: {
            isVisible: true,
            label: "Category",
            class: "",
            searchKey: "client_activities.category",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "category"
        },
        shift_start: {
            isVisible: true,
            label: "Shift Start",
            class: "",
            searchKey: "client_activities.shift_start",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "shift_start"
        },
        shift_end: {
            isVisible: true,
            label: "Shift End",
            class: "",
            searchKey: "client_activities.shift_end",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "shift_end"
        },
        created_at: {
            isVisible: true,
            label: "Created At",
            class: "",
            searchKey: "client_activities.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "created_at"
        },
        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "client_activities.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_activities",
            commonSearchKey: "client_activities",
            commonSearchObjectKey: "updated_at"
        }
    },
    data: []
};
